type FileSizeUnit = 'B' | 'kB' | 'MB' | 'GB' | 'TB' | 'PB' | 'EB' | 'ZB' | 'YB';

export function friendlyFileSize(num: number): string {

    if (typeof num !== 'number' || isNaN(num)) {
      throw new TypeError('Expected a number');
    }

    const isNegative = num < 0;

    const exponentOrderedUnits: FileSizeUnit[] = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    if (isNegative) {
        num = -num;
    }

    if (num < 1) {
        return (isNegative ? '-' : '') + num + ' B';
    }

    const exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), exponentOrderedUnits.length - 1);

    const numAsString = (num / Math.pow(1000, exponent)).toFixed(2);

    const unit = exponentOrderedUnits[exponent];

    return (isNegative ? '-' : '') + numAsString + ' ' + unit;
}
